<template>
  <form class="form">
    <div class="mb-3">
      <label for="code" class="form-label">Please Enter your code!</label>
      <input
        type="password"
        class="form-control"
        id="code"
        v-model="activationCode"
      />
    </div>

    <div class="text-end mt-5">
      <button
        v-if="isReady"
        type="submit"
        class="btn btn-main-dark"
        @click="confirmationEmail"
      >
        {{ $store.state.language.send }}
      </button>
      <button v-else type="submit" class="btn btn-main-dark disabled" disabled>
        {{ $store.state.language.send }}
      </button>

      <router-link
        v-if="signIn"
        :to="{ name: 'Signin' }"
        custom
        v-slot="{ navigate }"
      >
        <span
          role="link"
          @click="navigate"
          class="btn ms-3"
          @keypress.enter="navigate"
        >
          {{ $store.state.language.signin }}
        </span>
      </router-link>
    </div>
  </form>
</template>

<script>
export default {
  name: "ConfirmationEmail",

  data() {
    return {
      activationCode: "",
      isReady: false,
      signIn: true,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.state.modules.api
        .validatToken(this.$route.params.token)
        .then((resp) => {
          if (resp.status != 200 || resp.data.data.activation == "active") {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                message: "The link has already been used",
              },
              2500
            );
            this.$router.push({ name: "LandingPage" });
          } else if (localStorage.account) {
            if (JSON.parse(localStorage.account).token) {
              this.signIn = false;
            }
          }
        });
    });
  },

  watch: {
    activationCode() {
      this.isReady =
        this.activationCode.length > 10 && this.activationCode.length < 15;
    },
  },

  methods: {
    confirmationEmail() {
      event.preventDefault();
      if (this.isReady) {
        this.$store.state.utils.processing = true;
        const data = {
          activation_code: this.activationCode,
        };

        this.$store.state.modules.api
          .confirmation(data, this.$route.params.token)
          .then((resp) => {
            this.activationCode = "";
            if (resp.status == 200) {
              this.$router.push({ name: "CPanel" });
            } else {
              this.$store.state.utils.setNewNotifications(
                {
                  type: "warning",
                  title: "Fehlermeldung",
                  message: "Etwas ist schief gelaufen. :(",
                },
                2500
              );
            }
            this.$store.state.utils.processing = false;
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        this.$store.state.utils.setNewNotifications(
          {
            type: "warning",
            message: "Check the entries are correct",
          },
          2500
        );
      }
    },
  },
};
</script>
